import React from 'react';
import {
  checkOutAllPlayers, removeAllPlayersFromTeams, resetAllTeamsStats, clearHistory,
} from 'redux/slices';
import { useDispatch } from 'react-redux';
import { ConfirmationModal } from './ConfirmationModal';

export function CheckoutAllPlayers({ fullWidth = true }) {
  const dispatch = useDispatch();
  const handleCheckoutAllPlayers = () => {
    dispatch(checkOutAllPlayers());
    dispatch(removeAllPlayersFromTeams());
    dispatch(resetAllTeamsStats());
    dispatch(clearHistory());
  };
  return (
    <ConfirmationModal
      title="Deseja remover todos os jogadores da quadra?"
      description="Todos saem da quadra e da fila, e o histórico do dia é apagado. Essa ação não pode ser desfeita."
      triggerLabel="Fazer checkout de todos os jogadores"
      handleConfirm={handleCheckoutAllPlayers}
      triggerConfig={{
        variant: 'contained',
        color: 'error',
        sx: fullWidth ? { width: '100%' } : {},
      }}
    />
  );
}
